// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePatientAccountApi = class EdgePatientAccountApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param getCaseRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientAccountGetCase(getCaseRequestModel, xProgramId) {
        const _url_ = '/edge/patientAccount/GetCase';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getCaseRequestModel' is not null or undefined
        if (getCaseRequestModel === null || getCaseRequestModel === undefined) {
            throw new Error('Required parameter getCaseRequestModel was null or undefined when calling patientAccountGetCase.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getCaseRequestModel, "GetCaseRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountGetCaseDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientAccountGetPatientAccount(xProgramId) {
        const _url_ = '/edge/patientAccount/GetPatientAccount';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountGetPatientAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientAccountGetPatientActiveEnrollments(xProgramId) {
        const _url_ = '/edge/patientAccount/GetPatientActiveEnrollments';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountGetPatientActiveEnrollmentsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param iIsPatientRegisteredRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientAccountIsPatientRegistered(iIsPatientRegisteredRequestModel, xProgramId) {
        const _url_ = '/edge/patientAccount/IsPatientRegistered';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iIsPatientRegisteredRequestModel' is not null or undefined
        if (iIsPatientRegisteredRequestModel === null || iIsPatientRegisteredRequestModel === undefined) {
            throw new Error('Required parameter iIsPatientRegisteredRequestModel was null or undefined when calling patientAccountIsPatientRegistered.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iIsPatientRegisteredRequestModel, "IIsPatientRegisteredRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountIsPatientRegisteredDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param iPatientRegistrationRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientAccountPatientRegistration(iPatientRegistrationRequestModel, xProgramId) {
        const _url_ = '/edge/patientAccount/PatientRegistration';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iPatientRegistrationRequestModel' is not null or undefined
        if (iPatientRegistrationRequestModel === null || iPatientRegistrationRequestModel === undefined) {
            throw new Error('Required parameter iPatientRegistrationRequestModel was null or undefined when calling patientAccountPatientRegistration.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iPatientRegistrationRequestModel, "IPatientRegistrationRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountPatientRegistrationDefaultResponse");
        }
        return response;
    }
};
EdgePatientAccountApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePatientAccountApi);
export { EdgePatientAccountApi };
//# sourceMappingURL=edgePatientAccountApi.js.map